// Mock data for Spearca Inc. website

export const companyInfo = {
  name: "Spearca Concepts Inc.",
  shortName: "Spearca",
  tagline: "IT Services & Software Solutions",
  heroHeadline: "Build. Scale. Succeed.",
  heroSubheadline: "We deliver IT services and software solutions that enable businesses to scale, streamline operations, and deliver digital products with confidence.",
  mission: "Help businesses move faster and operate smarter through technology.",
  email: "info@spearcainc.com",
  phone: "+1 214 519 4480",
  address: "Dallas, TX"
};

export const services = [
  {
    id: 1,
    title: "Custom Software Solutions",
    description: "Tailored software platforms designed to address your unique business challenges and operational needs.",
    icon: "Code2"
  },
  {
    id: 2,
    title: "Web & Application Systems",
    description: "Robust web applications and systems built for performance, security, and seamless user experience.",
    icon: "Globe"
  },
  {
    id: 3,
    title: "MVP Development",
    description: "Rapid product development and MVP delivery to help you validate ideas and get to market faster.",
    icon: "Rocket"
  },
  {
    id: 4,
    title: "System Integration",
    description: "Seamless integration of digital systems to unify operations and enable digital transformation.",
    icon: "Link"
  },
  {
    id: 5,
    title: "IT Services & Support",
    description: "Ongoing optimization, maintenance, and technical support to keep your systems running smoothly.",
    icon: "Headphones"
  }
];

export const features = [
  {
    id: 1,
    title: "Clarity First",
    description: "We start by understanding your business objectives, then deliver solutions that are practical and reliable.",
    icon: "Target"
  },
  {
    id: 2,
    title: "Built to Scale",
    description: "Every solution is designed to support sustainable growth without unnecessary complexity.",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Reliable Execution",
    description: "We provide accountability and measurable business value as your strategic technology partner.",
    icon: "Shield"
  },
  {
    id: 4,
    title: "Seamless Integration",
    description: "Solutions designed to integrate seamlessly into your existing operations and workflows.",
    icon: "Puzzle"
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Discovery",
    description: "We dive deep into understanding your business goals, challenges, and technical requirements."
  },
  {
    step: 2,
    title: "Strategy",
    description: "We design a comprehensive solution architecture tailored to your specific needs."
  },
  {
    step: 3,
    title: "Development",
    description: "Our team builds your solution with best practices, clean code, and rigorous testing."
  },
  {
    step: 4,
    title: "Launch & Support",
    description: "We deploy your solution and provide ongoing support to ensure long-term success."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Chen",
    role: "CTO, TechFlow Startup",
    content: "Spearca transformed our MVP idea into a fully functional product in record time. Their technical expertise and business understanding made them the perfect partner.",
    avatar: "SC"
  },
  {
    id: 2,
    name: "Michael Roberts",
    role: "Operations Director, ScaleUp Co",
    content: "The system integration project was complex, but Spearca delivered beyond expectations. Our operations are now 40% more efficient.",
    avatar: "MR"
  },
  {
    id: 3,
    name: "Emily Watson",
    role: "Founder, DataDriven Inc",
    content: "Working with Spearca has been a game-changer. They don't just write code; they understand business and deliver real value.",
    avatar: "EW"
  }
];

export const stats = [
  { value: "150+", label: "Projects Delivered" },
  { value: "98%", label: "Client Satisfaction" },
  { value: "50+", label: "Active Clients" },
  { value: "8+", label: "Years Experience" }
];

export const navLinks = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Process", href: "#process" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" }
];
